import React from "react"

import MonolineTextBlock from "components/monoline"
import { ButtonContainer } from "components/grid/styles"
import {
  Container,
  TitleContainer,
  Title,
  Line,
  MindbodygreenTitleWrapper,
  MindbodygreenTitle,
  Description,
  LogoContainer,
  Logo,
  HeaderWrapper,
} from "./styles"

const SectionHeading = ({
  className,
  title,
  subtitle,
  useMonoline,
  logo,
  logoAspectRatio,
  mobileNoBorder,
  textComponent,
  useLine,
  useSlimTitle,
  showDescriptionOnMobile,
  buttonElement,
  hasTopButton,
  isNested,
  isScrollable,
  isFocusedItem,
  isRailItem,
  hideHeadlineOnMobile,
}) => (
  <Container
    className={className}
    textComponent={textComponent}
    isFocusedItem={isFocusedItem}
    hideHeadlineOnMobile={hideHeadlineOnMobile}
    isRailItem={isRailItem}
  >
    {title &&
      (title === "Mindbodygreen" ? (
        <MindbodygreenTitleWrapper>
          <MindbodygreenTitle />
        </MindbodygreenTitleWrapper>
      ) : (
        <HeaderWrapper isRailItem={isRailItem}>
          <TitleContainer useLine={useLine}>
            <Title
              className="section-heading-title"
              hasSubtitle={!!subtitle}
              hasLogo={!!logo}
              mobileNoBorder={mobileNoBorder}
              useSlimTitle={useSlimTitle}
              hasDescription={showDescriptionOnMobile && Boolean(title && subtitle)}
              hasTopButton={hasTopButton}
              isNested={isNested}
              isScrollable={isScrollable}
              hideHeadlineOnMobile={hideHeadlineOnMobile}
              isRailItem={isRailItem}
            >
              {useMonoline && <MonolineTextBlock html={title} />}
              {!useMonoline && title}
            </Title>
            {hasTopButton && <ButtonContainer>{buttonElement}</ButtonContainer>}
          </TitleContainer>
          {useLine && <Line isNested={isNested} />}
        </HeaderWrapper>
      ))}
    {title && subtitle && (
      <Description
        isScrollable={isScrollable}
        dangerouslySetInnerHTML={{ __html: subtitle }}
        showDescriptionOnMobile={showDescriptionOnMobile}
        isRailItem={isRailItem}
      />
    )}
    {title && logo && (
      <LogoContainer mobileNoBorder={mobileNoBorder}>
        <Logo
          baseUrl={logo}
          aspectRatio={logoAspectRatio}
          images={[
            {
              transforms: "e_trim/w_150,q_90,f_auto,fl_lossy",
            },
          ]}
          alt={title}
        />
      </LogoContainer>
    )}
  </Container>
)
export default SectionHeading
